<script>
export default {
  name: "DisabledProgramSessionFeesSummary",
};
</script>

<script setup>
import ExpandingSection from "@/components/shared/section/ExpandingSection.vue";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
</script>

<template>
  <div>
    <ExpandingSection
      field-label="PROGRAM SESSION FEES SUMMARY"
      :expanded-by-default="true"
    >
      <template #content>
        <div class="grid grid-cols-1 gap-y-3">
          <div class="flex flex-col">
            <div class="flex items-center font-semibold mb-1">
              <InformationCircleIcon class="h-5 w-5 mr-2" />
              <span class="text-md">
                The fee summary will appear on save.
              </span>
            </div>
            <div class="pl-7">
              <span class="italic text-sm">
                Please set up the new program session and hit save to see the
                fees calculated. Each time you make a change, you will need to
                save to see the latest price.
              </span>
            </div>
          </div>
        </div>
      </template>
    </ExpandingSection>
  </div>
</template>
